// extracted by mini-css-extract-plugin
module.exports = {"withBottomBorder":"Match_withBottomBorder_2-CXX"};